import request from '@aned/request';

// 查询
export async function select(params) {
  return request('/api/route/capacityMonitor/select', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
